/**
 * Bound a capture commit so Save can never fail silently. On iPhone Safari a
 * camera photo made the IndexedDB write hang — no success, no error — and the
 * Save handlers fired the commit with `void`, so the tap did nothing at all
 * (2026-10-01). The caller turns a non-ok outcome into an on-screen error.
 */

export type SaveOutcome =
  | { ok: true }
  | { ok: false; reason: "failed"; error: unknown }
  | { ok: false; reason: "timed_out" };

export function guardSave(commit: Promise<unknown>, timeoutMs: number): Promise<SaveOutcome> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve({ ok: false, reason: "timed_out" }), timeoutMs);
    commit.then(
      () => { clearTimeout(timer); resolve({ ok: true }); },
      (error: unknown) => { clearTimeout(timer); resolve({ ok: false, reason: "failed", error }); },
    );
  });
}
